import { useState, useEffect, useRef } from "react";
import styled from "styled-components";

function Carousel({ content, delay }) {
  // const delay = 2500;
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === content.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);

  return (
    <CarouselWrapper>
      <div
        className="slideshowSlider"
        style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
      >
        {content.map((item, index) => (
          <div className="slide" key={index}>
            {item}
          </div>
        ))}
      </div>

      <div className="slideshowDots">
        {content.map((_, idx) => (
          <div
            key={idx}
            className={`slideshowDot${index === idx ? " active" : ""}`}
            onClick={() => {
              setIndex(idx);
            }}
          ></div>
        ))}
      </div>
    </CarouselWrapper>
  );
}

const CarouselWrapper = styled.div`
  margin: 0 auto;
  overflow: hidden;
  .slideshowSlider {
    white-space: nowrap;
    transition: ease 1000ms;
  }

  .slide {
    display: inline-block;
    width: 100%;
    border-radius: 40px;
  }

  /* Buttons */

  .slideshowDots {
    text-align: center;
  }
  .slideshowDot {
    display: inline-block;
    height: 5px;
    border-radius: 3px;
    width: 30px;
    cursor: pointer;
    margin: 15px 7px 0px;
    background-color: #a4b9ca;
  }
  .slideshowDot.active {
    background-color: #1c507a;
  }
`;

export default Carousel;
